<div [attr.data-badge]="collection.count">
  <img [src]="collection.thumbnail" class="thumbnail" />
</div>
<span class="flex-grow-1 ml-5" [class.font-weight-bold]="isHighlighted">{{
  collection.name
}}</span
><button type="button" class="btn visit-collection-btn ml-2"></button>
